/** @type {_restream.Rule} */
const replaceDefault = {
  re: /^( *)(export\s+)(default\s+)/m,
  replacement,
}

/**
 * @suppress {globalThis}
 * @type {_alamode.ÀLaModeReplacer}
 */
function replacement(match, b, exportsSeg, defaultSeg) {
  const e = exportsSeg.replace(/export ?/, 'module.')
  const d = defaultSeg.replace(/default ?/, 'exports=')
  return `${b}${e}${d}`
}

export default replaceDefault

/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('restream').Rule} _restream.Rule
 */
/**
 * @suppress {nonStandardJsDocs}
 * @typedef {import('alamode/types').ÀLaModeReplacer} _alamode.ÀLaModeReplacer
 */